/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {
  Grid,
  MenuItem,
  Box,
  FormControl,
  FormHelperText,
  FormGroup,
  Chip
} from '@mui/material';
import { Formik } from 'formik';
import { useMutation, useQuery } from '@apollo/client';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DateTimePicker from '@atoms/DateTimePicker';
import Downshift from 'downshift';
import TextField from '@atoms/TextField';
import { colors } from '@app/config/colors';
import Typography from '@atoms/Typography';

import Checkbox from '@atoms/Checkbox';
import Radio from '@atoms/Radio';
import Recaptcha from '@atoms/Recaptcha';
import FieldErrors from '@atoms/FieldErrors';
import LocationInput from '@atoms/LocationInput';
import Spacer from '@atoms/Spacer';
import FileUploader from '@molecules/FileUploader';
import VideoLink from '@molecules/VideoLink';
import MutationsStatus from '@molecules/MutationsStatus';
import PhoneInput from '@molecules/PhoneInput';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import CloudIcon from '@mui/icons-material/Cloud';

import { useTranslation } from '@app/config/i18n';
import { CREATE_APPLICATION_MUTATION, UPDATE_APPLICATION_SUBMISSION_MUTATION } from '@app/apollo/mutations';
import {
  redirectToRoute,
  getPickerFormat,
  getFileUrl,
  getOpportunityPaymentType,
} from '@app/helpers';
import { APPROVAL_TYPES, FIELDS_ENUM, OPPORTUNITY_PAYMENT, SUBTYPE_ENUM } from '@app/constants';
import {
  MY_ORGANISATIONS_QUERY,
  USER_QUERY,
} from '@app/apollo/queries';
import RoundedButton from '@app/components/atoms/RoundedButton';
import Autocomplete from '@app/components/molecules/Autocomplete';
import Button from '../../../../atoms/Button';

import GroupMembers from '../GroupMembers';

import {
  DateContainer,
  Divider,
  ApplyButton,
  FormField,
  CaptchaContainer,
  StyledGrid,
} from './style';

const gridSizes = { xs: 12, sm: 12, md: 12, lg: 12 };

const labelVariant = 'body1';

const FormBodyV2 = ({
  myOpportunity,
  applicationForm,
  opportunitySlug,
  preview,
  initialValue,
  setInitialValue,
  applicationId,
  showTerms,
  setShowTerms,
  setAgreeTerms,
  agreeTerms,
  showApplicationForm,
  setShowApplicationForm,
  multiTrack,
  handleCloseModal,
  setMultiTrackApplicationForm,
  editMode,
}) => {
  const { t } = useTranslation(['wizard', 'common', 'applications', 'footer', 'opportunity']);

  const [selectedTrack, setSelectedTrack] = useState('');
  const trackNames = myOpportunity.tracks.map(track => track.track_name);
  const submissionForms = myOpportunity.tracks.map(track => track.submission_form);
  const submissionFormFields = submissionForms.map(form => form.fields);
  const selectedTrackIndex = trackNames.indexOf(selectedTrack || initialValue?.track?.track_name);
  const selectedTrackID = myOpportunity.tracks.map(track => track.id);

  const [inputTagsValue, setInputTagsValue] = useState('');
  const [keywords, setKeywords] = useState([]);

  const { data: { me: userInfo } = {} } = useQuery(USER_QUERY);
  const { data: organisationData } = useQuery(MY_ORGANISATIONS_QUERY);

  useEffect(() => {
    if (showApplicationForm) {
      const element = document.querySelector(`[id="title"]`);
      if (element) {
        const {offsetTop} = element;
        window.scrollTo({
          top: offsetTop - 250,
          behavior: "smooth"
        });
      }
    }
  }, []);

  const newApplicationCompleted = (successData) => {
    // const isPaid = opportunity.payment_details && opportunity.payment_details.length > 0;
    if (successData) {
      if (!applicationId) {
        // eslint-disable-next-line no-lonely-if
        const currentOrganisations =
          organisationData && myOpportunity.organisation &&
          organisationData.myOrganisations.find((org) => org.id === myOpportunity.organisation.id);
        if (currentOrganisations) {
          redirectToRoute({}, 'opportunity_dashboard', {
            params: { slug: opportunitySlug },
          });
        } else {
          redirectToRoute({}, 'submission_application_complete', {
            params: { id: successData.createSubmissionApplication.id },
          });
        }
      } else {
        handleCloseModal();
        redirectToRoute({}, 'opportunity_dashboard', {
          params: { slug: opportunitySlug },
        });
      }
      setShowApplicationForm(false);
    }
  };

  const cancelEditingApplication = () => {
    redirectToRoute({}, 'opportunity_dashboard', {
      params: { slug: opportunitySlug },
    });
  };

  const [
    newApplicationMutation,
    { loading: mutationLoading, error: mutationError, data: mutationData },
  ] = useMutation(CREATE_APPLICATION_MUTATION, {
    onCompleted: newApplicationCompleted
  });

  const [
    updateApplicationMutation,
    { loading: updateMutationLoading, error: updateMutationError, data: updateMutationData },
  ] = useMutation(  UPDATE_APPLICATION_SUBMISSION_MUTATION, {
    onCompleted: newApplicationCompleted
  });

  const createApplicationHandler = (values) => {
    const { opportunity, track, fields, members, recaptcha } = values;

    let newFields = Object.keys(fields).map((key) => ({ field: key, value: fields[key] }));
    // let newFields = [...fields];
    members?.forEach((member, index) => {
      const newMember = member?.map((elem) => ({
        ...elem,
        group_idx: index,
      }));
      newFields = [...newFields, ...newMember];
    });

    const applicationInput = {
      opportunity,
      track: selectedTrackIndex >= 0 ? selectedTrackID[selectedTrackIndex] : track,
      fields: newFields
    };

    if (!mutationData) {
      if (applicationId) {
        updateApplicationMutation({
          variables: {
            id: applicationId,
            input: {
              fields: applicationInput.fields
            }
          }
        });
      } else {
        newApplicationMutation({
          variables: {
            input: applicationInput
          }
        });
      }
    }
  };

  const getValidationSchema = (form) => {
    const fieldsValidation = {};
    const membersValidation = {};
    form.fields && form.fields.forEach((field) => {
      if (field.is_required && field.type !== FIELDS_ENUM.MANDATORY_AUTHORS) {
        fieldsValidation[field.id] = Yup.mixed().required(t('common:validation.req'));
      }
      if (field.is_required && field.type === FIELDS_ENUM.MANDATORY_AUTHORS) {
        membersValidation.members = Yup.array()
          .required(t('common:validation.req'))
          .min(1, t('common:validation.one_member'));
      }
    });

    const validationList = {
      fields: Yup.object().shape({ ...fieldsValidation }),

      ...membersValidation,
    };

    const validationSchema = Yup.object().shape(validationList);

    return validationSchema;
  };

  return (
    <>
      <MutationsStatus
        loading={mutationLoading || updateMutationLoading}
        error={mutationError || updateMutationError}
        success={mutationData || updateMutationData}
      />
      <>
        {((submissionForms && submissionForms.length > 0) || applicationForm.fields.length > 0) && (
          <Formik
            initialValues={{
              opportunity: initialValue.opportunity,
              track: initialValue.track,
              fields: { ...initialValue.fields },
              members: [...initialValue.members],
              recaptcha: null,
            }}
            enableReinitialize
            onSubmit={createApplicationHandler}
            validationSchema={getValidationSchema(selectedTrackIndex >= 0 && submissionForms && submissionForms.length > 0 ? submissionForms[selectedTrackIndex] : applicationForm)}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setValues,
              validateForm,
              setFieldValue
              // dirty
            }) => {
              // useWarnIfUnsavedChanges(dirty);

              const updateFieldValue = (field, value) => {
                const newVals = { ...values };
                newVals.fields[field.id] = value;
                setValues(newVals);
                setInitialValue(newVals);
              };

              const handleInputTagsChange = (field) => (event, value) => {
                let newSelectedItem = [...values.field];
                if (newSelectedItem.indexOf(value) === -1) {
                  newSelectedItem = [...newSelectedItem, value];
                }
                setInputTagsValue('');
                updateFieldValue(field, value);
              }

              const showTermsHandler = () => {
                const newVals = { ...values };
                setInitialValue(newVals);
                if (submissionForms && selectedTrackIndex >= 0) {
                  setMultiTrackApplicationForm(submissionForms[selectedTrackIndex].terms);
                }
                setShowTerms(!showTerms);
              };


              const getFieldValue = (field) => {
                if (field.type === FIELDS_ENUM.DATETIME_FIELD && !values.fields[field.id]) {
                  return null;
                }

                return values.fields[field.id];
              };

              const handleInputTagsKeyDown = (field) => (event) => {
                const oldValue = getFieldValue(field) || [];
                const newKeywords = [...oldValue];
                if (event.key === 'Enter') {
                  const duplicatedValues = newKeywords.indexOf(event.target.value.trim());

                  if (duplicatedValues !== -1) {
                    setInputTagsValue('');
                    return;
                  }
                  if (!event.target.value.replace(/\s/g, '').length) return;

                  newKeywords.push(event.target.value.trim());
                  updateFieldValue(field, newKeywords);
                  setKeywords(newKeywords);
                  setInputTagsValue('');
                }
                if (
                  newKeywords.length &&
                  !inputTagsValue.length &&
                  event.key === 'Backspace'
                ) {
                  updateFieldValue(field, newKeywords.slice(0, newKeywords.length - 1));
                  setKeywords(newKeywords.slice(0, newKeywords.length - 1));
                }
              }

              const handleInputTagsDelete = (field) => (event) => {
                const oldValue = getFieldValue(field) || [];
                const newKeywords = [...oldValue];
                newKeywords.splice(newKeywords.indexOf(field), 1);
                updateFieldValue(field, newKeywords);
              };

              const getMediaValue = (field) => {
                const mediaVal = getFieldValue(field) || [];
                const media = mediaVal.map((file) => getFileUrl(file.path));

                return media;
              };

              const getFieldError = (field) =>
                errors.fields && errors.fields[field.id];
              const textChangeHandler = (field) => (e) => {
                updateFieldValue(field, e.target.value.trim() ? e.target.value : '');
              };

              const filesChangeHandler = (field) => (fileItems) => {
                const filesValue = getFieldValue(field);
                const newFiles = fileItems.map((file) => {
                  const { name, path } = file;
                  return { name, path };
                });
                const newValue = filesValue ? [...filesValue, ...newFiles] : [...newFiles];
                updateFieldValue(field, newValue);
              };

              const fileRemoveHandler = (field) => (open, clear, index) => {
                const filesValue = getFieldValue(field);
                const newValue = [...filesValue];
                newValue.splice(index, 1);
                updateFieldValue(field, newValue);

                clear();
              };

              /**
               * @description Handler to change opportunity type array based on selected checkbox
               * @param {*} event Checkbox event
               */
              const checkboxListChangeHandler = (field) => (event) => {
                const oldValue = getFieldValue(field);
                const newValues = oldValue || [];
                if (event.target.checked) {
                  newValues.push(event.target.value);
                } else {
                  newValues.splice(newValues.indexOf(event.target.value), 1);
                }
                updateFieldValue(field, newValues);
              };

              // const checkboxChangeHandler = field => () => {
              //   const oldValue = getFieldValue(field);

              //   updateFieldValue(field, !oldValue);
              // };

              /**
               * @description handler for updating video links.
               * @param {string} value new video link
               * @param {integer} index video link id
               */
              const linksChangeHandler = (field) => (value, index) => {
                const oldValue = getFieldValue(field);
                const newLinks = [...oldValue];
                newLinks[index] = value;
                updateFieldValue(field, newLinks);
              };

              /**
               * @description handler for adding new empty link.
               */
              const addLinkHandler = (field) => () => {
                const oldValue = getFieldValue(field);
                updateFieldValue(field, oldValue ? ['', ...oldValue] : ['']);
              };

              /**
               * Handler for removing video link
               * @param {integer} index video link id
               */
              const removeLinkHandler = (field) => (index) => {
                const oldValue = getFieldValue(field);
                const newLinks = [...oldValue];
                newLinks.splice(index, 1);
                updateFieldValue(field, [...newLinks]);
              };

              const setMembers = (members) => {
                const newValues = { ...values };
                newValues.members = members;
                setValues(newValues);
                setInitialValue(newValues);
              };

              const submitForm = () => {
                validateForm().then((err) => {
                  if (Object.keys(err).length === 0 && err.constructor === Object) {
                    handleSubmit();
                  } else {
                    // Scroll to the first error
                    const firstError = Object.keys(err)[0];
                    // const selector = `[id="${firstError}"], [name="${firstError}"] `;
                    if (firstError !== 'fields') {
                      const selector = `[id="${firstError}"]`;

                      const errorElement = document.querySelector(selector);
                      // document.getElementsByName(firstError).focus();
                      if (errorElement) {
                        errorElement.scrollIntoView({
                          behavior: 'smooth',
                          block: 'center',
                          inline: 'start',
                        });
                        setTimeout(() => {
                          errorElement.focus();
                        }, 1100);
                      }
                    } else {
                      const fieldsErrors = Object.keys(err.fields);
                      const selector = `[name="${fieldsErrors[0]}"]`;
                      const errorElement = document.querySelector(selector);
                      // document.getElementsByName(firstError).focus();
                      if (errorElement) {
                        errorElement.scrollIntoView({
                          behavior: 'smooth',
                          block: 'center',
                          inline: 'start',
                        });
                        setTimeout(() => {
                          errorElement.focus();
                        }, 1100);
                      }
                    }
                  }
                });
              };

              const renderMandatoryFields = (fields) =>
                fields.map((field) => {
                  let fieldView = '';
                  let label;

                  try {
                    label = JSON.parse(field.label);
                  } catch (error) {
                    label = field.label;
                  }

                  if (field.type === FIELDS_ENUM.MANDATORY_TITLE) {
                    fieldView = (
                      <FormField id='title' item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            value={values && getFieldValue(field)}
                            label={typeof(field.label) === 'string' ? field.label : label}
                            placeholder="Enter the title of the event"
                            InputLabelProps={{ shrink: true }}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            disabled={preview}
                            error={getFieldError(field)}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            helperText={getFieldError(field)}
                          // error={touched[field.id] && errors[field.id]}
                          // helperText={errors[field.id]}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.MANDATORY_ABSTRACT) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            value={values && getFieldValue(field)}
                            label={typeof(field.label) === 'string' ? field.label : label}
                            placeholder="Enter the abstract of the submission here"
                            InputLabelProps={{ shrink: true }}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            disabled={preview}
                            multiline
                            rows={4}
                            rowsMax={15}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            error={getFieldError(field)}
                            helperText={getFieldError(field)}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.MANDATORY_PAPER) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <FileUploader
                            name={field.id}
                            files={getFieldValue(field) || []}
                            multiple={field.subtype === SUBTYPE_ENUM.MULTIPLE}
                            onChange={filesChangeHandler(field)}
                            // label={typeof(field.label) === 'string' ? field.label : label}
                            icon={<CloseIcon />}
                            uploaderText={t('common:upload')}
                            disabled={preview}
                            type="paper"
                            value={values && getFieldValue(field)}
                            onIconClick={fileRemoveHandler(field)}
                            autoUpload
                          />
                        </Box>

                        <FieldErrors error={getFieldError(field)} />
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.MANDATORY_AUTHORS) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <>
                          <GroupMembers
                            name="members"
                            id="members"
                            groupField={field}
                            setMembers={setMembers}
                            members={values.members}
                            preview={preview}
                          />
                          {errors.members && (
                            <FormHelperText error>{errors.members}</FormHelperText>
                          )}
                        </>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  }
                  return fieldView;
                });

              const renderFields = (fields) =>
                fields.map((field) => {
                  let fieldView = '';
                  let label;

                  try {
                    label = JSON.parse(field.label);
                  } catch (error) {
                    label = field.label;
                  }

                  if (field.type === FIELDS_ENUM.DEMONSTRATION) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <FileUploader
                            name={field.id}
                            files={getFieldValue(field) || []}
                            multiple={field.subtype === SUBTYPE_ENUM.MULTIPLE}
                            onChange={filesChangeHandler(field)}
                            // label={typeof(field.label) === 'string' ? field.label : label}
                            icon={<CloseIcon />}
                            uploaderText={t('common:upload')}
                            disabled={preview}
                            type="paper"
                            value={values && getFieldValue(field)}
                            onIconClick={fileRemoveHandler(field)}
                            autoUpload
                          />
                          <FieldErrors error={getFieldError(field)} />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.KEYWORDS) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <Downshift
                            id="downshift-multiple"
                            name="keywords"
                            inputValue={inputTagsValue}
                            onChange={handleInputTagsChange(field)}
                          >
                            {({ getInputProps }) => {
                              const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
                                onKeyDown: handleInputTagsKeyDown(field),
                                // placeholder
                              });
                              return (
                                <div>
                                  <TextField
                                    label="Keywords"
                                    placeholder="Start typing and press enter to insert the keyword"
                                    helperText="Separate each keyword by hitting 'Enter'."
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    InputProps={{
                                      startAdornment:
                                        keywords.length > 0 &&
                                        keywords.map((item, index) => (
                                          <Chip
                                            style={{ marginRight: '8px' }}
                                            key={item}
                                            tabIndex={-1}
                                            label={item}
                                            onDelete={handleInputTagsDelete(item)}
                                          />
                                        )),
                                      onBlur,
                                      onChange: (event) => {
                                        setInputTagsValue(event.target.value);
                                        onChange(event);
                                      },
                                      onFocus,
                                    }}
                                    {...inputProps}
                                  />
                                </div>
                              );
                            }}
                          </Downshift>
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (
                    field.type === FIELDS_ENUM.TEXT_FIELD &&
                    field.subtype === SUBTYPE_ENUM.TEXT
                  ) {
                    // TODO: Handle link validation.
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            value={values && getFieldValue(field)}
                            // label={typeof(field.label) === 'string' ? field.label : label}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            disabled={preview}
                            error={getFieldError(field)}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            helperText={getFieldError(field)}
                          // error={touched[field.id] && errors[field.id]}
                          // helperText={errors[field.id]}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (
                    field.type === FIELDS_ENUM.TEXT_FIELD &&
                    field.subtype === SUBTYPE_ENUM.TEXTAREA
                  ) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            value={values && getFieldValue(field)}
                            // label={label}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            disabled={preview}
                            multiline
                            rows={4}
                            rowsMax={15}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            error={getFieldError(field)}
                            helperText={getFieldError(field)}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (
                    field.type === FIELDS_ENUM.CONFLICT_OF_INTEREST &&
                    field.subtype === SUBTYPE_ENUM.TEXT
                  ) {
                    // TODO: Handle link validation.
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            value={values && getFieldValue(field)}
                            label={label}
                            placeholder="Insert conflict of interest"
                            InputLabelProps={{ shrink: true }}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            disabled={preview}
                            error={getFieldError(field)}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            helperText={getFieldError(field)}
                          // error={touched[field.id] && errors[field.id]}
                          // helperText={errors[field.id]}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (
                    field.type === FIELDS_ENUM.CONFLICT_OF_INTEREST &&
                    field.subtype === SUBTYPE_ENUM.TEXTAREA
                  ) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            value={values && getFieldValue(field)}
                            label={label}
                            placeholder="Insert conflict of interest"
                            InputLabelProps={{ shrink: true }}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            disabled={preview}
                            multiline
                            rows={4}
                            rowsMax={15}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            error={getFieldError(field)}
                            helperText={getFieldError(field)}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.LINK) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <TextField
                            label={field.subtype === 'linkedin' && 'Link to your Linkedin account' ||
                              field.subtype === 'youtube' && 'Link to your Youtube channel' ||
                              field.subtype === 'website' && 'Link to your Website' ||
                              field.subtype === 'facebook' && 'Link to your Facebook account' ||
                              field.subtype === 'twitter' && 'Link to your Twitter account' ||
                              field.subtype === 'instagram' && 'Link to your Instagram account' ||
                              field.subtype === 'soundcloud' && 'Link to your Soundcloud account'}
                            placeholder="Insert link here"
                            InputLabelProps={{ shrink: true }}
                            name={field.id}
                            onChange={textChangeHandler(field)}
                            onBlur={handleBlur}
                            value={values && getFieldValue(field)}
                            disabled={preview}
                            // error={getFieldTouched(field) && getFieldError(field)}
                            error={getFieldError(field)}
                            helperText={getFieldError(field)}
                            InputProps={{
                              startAdornment: (
                                field.subtype === 'linkedin' && <LinkedInIcon color='secondary' sx={{ marginRight: '0.5rem' }} /> ||
                                field.subtype === 'youtube' && <YouTubeIcon color='secondary' sx={{ marginRight: '0.5rem' }} /> ||
                                field.subtype === 'website' && <InsertLinkIcon color='secondary' sx={{ marginRight: '0.5rem' }} /> ||
                                field.subtype === 'facebook' && <FacebookIcon color='secondary' sx={{ marginRight: '0.5rem' }} /> ||
                                field.subtype === 'twitter' && <TwitterIcon color='secondary' sx={{ marginRight: '0.5rem' }} /> ||
                                field.subtype === 'instagram' && <InstagramIcon color='secondary' sx={{ marginRight: '0.5rem' }} /> ||
                                field.subtype === 'soundcloud' && <CloudIcon color='secondary' sx={{ marginRight: '0.5rem' }} />
                              ),
                            }}
                          />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.VIDEO_LINK) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <VideoLink
                            // value={[]}
                            name={field.id}
                            value={getFieldValue(field) || []}
                            onChange={linksChangeHandler(field)}
                            onAddLink={addLinkHandler(field)}
                            onRemoveClick={removeLinkHandler(field)}
                            disabled={preview}
                          />
                          <FieldErrors error={getFieldError(field)} />
                        </Box>
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.FIGURES) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <FileUploader
                            name={field.id}
                            files={values && getMediaValue(field)}
                            multiple={field.subtype === SUBTYPE_ENUM.MULTIPLE}
                            onChange={filesChangeHandler(field)}
                            // label={label}
                            icon={<CloseIcon />}
                            uploaderText={
                              <Typography
                                variant="caption"
                                color="primary"
                                style={{ fontWeight: 600 }}
                              >
                                {t('common:upload')}
                              </Typography>
                            }
                            disabled={preview}
                            type="image"
                            value={values && getMediaValue(field)}
                            onIconClick={fileRemoveHandler(field)}
                            autoUpload
                          />
                        </Box>

                        <FieldErrors error={getFieldError(field)} />
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.AUDIO) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <FileUploader
                            name={field.id}
                            files={getFieldValue(field) || []}
                            multiple={field.subtype === SUBTYPE_ENUM.MULTIPLE}
                            onChange={filesChangeHandler(field)}
                            // label={label}
                            icon={<CloseIcon />}
                            uploaderText={t('common:upload')}
                            disabled={preview}
                            type="audio"
                            value={values && getFieldValue(field)}
                            onIconClick={fileRemoveHandler(field)}
                            autoUpload
                          />
                        </Box>
                        <FieldErrors error={getFieldError(field)} />
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.ATTACHMENT) {
                    fieldView = (
                      <FormField item {...gridSizes}>
                        <Typography className="fieldTitle" weight='600' variant="subtitle1">
                          {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                        </Typography>
                        <Box className="inputBox">
                          <FileUploader
                            name={field.id}
                            files={getFieldValue(field) || []}
                            multiple={field.subtype === SUBTYPE_ENUM.MULTIPLE}
                            onChange={filesChangeHandler(field)}
                            // label={label}
                            icon={<CloseIcon />}
                            uploaderText={t('common:upload')}
                            disabled={preview}
                            type="paper"
                            value={values && getFieldValue(field)}
                            onIconClick={fileRemoveHandler(field)}
                            autoUpload
                          />
                        </Box>

                        <FieldErrors error={getFieldError(field)} />
                        <Spacer height="4rem" />
                      </FormField>
                    );
                  } else if (field.type === FIELDS_ENUM.MULTIPLE_CHOICE ||
                    field.type === FIELDS_ENUM.TOPICS_OF_INTEREST) {
                    if (field.subtype === SUBTYPE_ENUM.CHECKBOX) {
                      fieldView = (
                        <>
                          <FormField item {...gridSizes}>
                            {/* <Typography variant="body1">{label}</Typography> */}

                            <FormControl
                              required
                              // error={getFieldTouched(field) && getFieldError(field)}
                              // helperText={ getFieldError(field)}
                              component="fieldset"
                            >
                              <Typography className="fieldTitle" weight='600' variant="subtitle1">
                                {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                              </Typography>
                              {/* <FormLabel component="legend">{label}</FormLabel> */}
                              <Box marginLeft="1rem" marginTop="1rem" width="100%">
                                <FormGroup>
                                  <Grid container spacing="1">
                                    {field.choices &&
                                      field.choices.length > 0 &&
                                      field.choices.map((choice) => (
                                        <Grid item xs={12}>
                                          <Checkbox
                                            label={choice}
                                            checked={
                                              getFieldValue(field) &&
                                              (getFieldValue(field) || []).includes(choice)
                                            }
                                            onChange={checkboxListChangeHandler(field)}
                                            name={field.id}
                                            value={choice}
                                            color="primary"
                                            onBlur={handleBlur}
                                            inputProps={{
                                              'aria-label': 'primary checkbox',
                                            }}
                                            disabled={preview}
                                          />
                                        </Grid>
                                      ))}
                                  </Grid>
                                </FormGroup>
                              </Box>
                            </FormControl>
                            <FieldErrors error={getFieldError(field)} />
                          </FormField>
                          <Spacer height="2rem" width='100%' />
                        </>
                      );
                    } else if (field.subtype === SUBTYPE_ENUM.RADIO) {
                      fieldView = (
                        <>
                          <FormField item {...gridSizes}>
                            <Typography className="fieldTitle" weight='600' variant="subtitle1">
                              {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                            </Typography>

                            <Box marginLeft="1rem" marginTop="1rem" width="100%">
                              <Radio.RadioGroup
                                aria-label="target"
                                name={field.id}
                                value={getFieldValue(field)}
                                onChange={textChangeHandler(field)}
                                onBlur={handleBlur}
                              >
                                <Grid container spacing="1">
                                  {field.choices &&
                                    field.choices.length > 0 &&
                                    field.choices.map((choice) => (
                                      <Grid item xs={12}>
                                        <Radio
                                          id={choice}
                                          label={choice}
                                          value={choice}
                                          color="primary"
                                          inputProps={{
                                            'aria-label': 'primary Radio',
                                          }}
                                          onBlur={handleBlur}
                                          disabled={preview}
                                        />
                                      </Grid>
                                    ))}
                                </Grid>
                              </Radio.RadioGroup>
                              <FieldErrors error={getFieldError(field)} />
                            </Box>
                          </FormField>
                          <Spacer height="2rem" width='100%' />
                        </>
                      );
                    } else if (field.subtype === SUBTYPE_ENUM.DROPDOWN) {
                      fieldView = (
                        <>
                          <FormField item {...gridSizes}>
                            <Typography variant={labelVariant}>
                              {typeof(field.label) === 'string' ? field.label : label} {field.is_required && '*'}
                            </Typography>
                            <TextField
                              select
                              // label={label}
                              name={field.id}
                              onChange={textChangeHandler(field)}
                              onBlur={handleBlur}
                              value={values && getFieldValue(field)}
                              // error={getFieldTouched(field) && getFieldError(field)}
                              error={getFieldError(field)}
                              helperText={getFieldError(field)}
                              disabled={preview}
                            >
                              {field.choices &&
                                field.choices.map((choice) => (
                                  <MenuItem key={choice} value={choice}>
                                    {choice}
                                  </MenuItem>
                                ))}
                            </TextField>
                          </FormField>
                        </>
                      );
                    }
                  }
                  return fieldView;
              });

                const onTracksChangeHandler = (event, value) => {
                  setSelectedTrack(value);
                };

              return (
                <>
                  {!editMode && !multiTrack && submissionForms && submissionForms.length > 0 && (
                    <>
                      <StyledGrid container>
                        <Grid item md={10}>
                          <Autocomplete
                            options={trackNames}
                            id="track"
                            name="track"
                            type="eventtypes"
                            getOptionLabel={(option) => option}
                            value={selectedTrack}
                            label="Select a track"
                            onChange={onTracksChangeHandler}
                          />

                          <Typography variant="caption" color="secondary">
                            Create a submission releated to a track
                          </Typography>
                        </Grid>
                      </StyledGrid>
                      <Divider />
                      <Spacer height="2rem" />
                    </>
                  )}
                  <Grid container justify="flex-start">
                    <Grid item {...gridSizes}>
                      <Grid container>
                        <FormField item {...gridSizes}>
                          <Spacer height="2rem" />
                        </FormField>
                        {renderMandatoryFields(selectedTrackIndex >= 0 && submissionForms && submissionForms.length > 0 ? submissionFormFields[selectedTrackIndex] : applicationForm.fields)}
                        {renderFields(selectedTrackIndex >= 0 && submissionForms && submissionForms.length > 0 ? submissionFormFields[selectedTrackIndex] : applicationForm.fields)}
                      </Grid>
                    </Grid>

                    {!userInfo && (
                      <FormField item {...gridSizes}>
                        <CaptchaContainer>
                          <Recaptcha
                            name="recaptcha"
                            setValue={setFieldValue}
                            value={values.recaptcha}
                            onChange={handleChange}
                            reset={!!mutationError}
                          />
                        </CaptchaContainer>
                      </FormField>
                    )}
                    <FormField item {...gridSizes}>
                      <Spacer height="1.5rem" />
                    </FormField>
                    {((selectedTrackIndex >= 0 && submissionForms && submissionForms.length > 0) || applicationForm) &&
                      (selectedTrackIndex >= 0 && submissionForms && submissionForms.length > 0 ? submissionForms[selectedTrackIndex].terms : applicationForm.terms) &&
                      (selectedTrackIndex >= 0 && submissionForms && submissionForms.length > 0 ? submissionForms[selectedTrackIndex].terms !== `<p><br></p>` : applicationForm.terms !== `<p><br></p>`) && (
                        <>
                          <Divider />
                          <FormField item {...gridSizes}>
                          <Spacer height="3rem" />
                            <Box display="flex" alignItems="center" mb={5}>
                              <Checkbox
                                label={null}
                                checked={agreeTerms || applicationId}
                                disabled={!preview && applicationId}
                                onChange={() => {
                                  setAgreeTerms(!agreeTerms);
                                }}
                                // name={field.id}
                                value={agreeTerms}
                                color="primary"
                                onBlur={handleBlur}
                                inputProps={{
                                  'aria-label': 'primary checkbox',
                                }}
                              // disabled={preview}
                              />
                              <Box pl={3} display="flex" flexDirection="column">
                                <Typography variant="caption">
                                  {t('opportunity:read_and_agree')}
                                </Typography>
                                <Button
                                  variant="text"
                                  color="primary"
                                  style={{
                                    textDecoration: 'underline',
                                    textTransform: 'capitalize',
                                    padding: 0,
                                  }}
                                  onClick={showTermsHandler}
                                  disabled={!preview && applicationId}
                                >
                                  {t('opportunity:opp_terms_condition')}
                                </Button>
                              </Box>
                            </Box>

                            {/* <TermsContainer
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                  __html: applicationForm.terms,
                                }}
                              /> */}
                          </FormField>
                        </>
                      )}
                  </Grid>

                  {!preview && !applicationId && Object.keys(errors).length > 0 && (
                    <Grid
                      item
                      xs={12}
                      marginTop="2rem"
                      marginBottom="3rem"
                      display="flex"
                      justifyContent="flex-start"
                    >
                      <FormHelperText sx={{ fontWeight: '600', fontSize: '16px' }} error> {t('common:validation.fill')} </FormHelperText>
                    </Grid>
                  )}
                  {!preview && !applicationId && ((submissionForms && submissionForms.length > 0 && submissionForms.terms) || (applicationForm && applicationForm.terms)) ? (
                    <Grid container justifyContent="center">
                      <Grid item xs={6} md={3}>
                        <ApplyButton
                          aria-label="apply"
                          variant="extended"
                          color="primary"
                          loading={mutationLoading || !agreeTerms}
                          onClick={submitForm}
                        >
                          {editMode ? t('common:save') : t('common:apply')}
                          <ChevronRightIcon />
                        </ApplyButton>
                      </Grid>
                    </Grid>
                  ) : (
                    !preview &&
                    !applicationId && (
                      <Grid container justifyContent="center">
                        <Grid item xs={6} md={3}>
                          <RoundedButton
                            variant="contained"
                            sx={{ backgroundColor: colors.primaryColor[800] }}
                            fullWidth
                            loading={mutationLoading}
                            disabled={selectedTrackIndex < 0 && applicationForm.fields.length === 0}
                            onClick={submitForm}
                          >
                            {editMode ? t('common:save') : t('common:apply')}
                          </RoundedButton>
                        </Grid>
                      </Grid>
                    )
                  )}
                  {!preview && applicationId && (
                    <Box
                      marginTop="2rem"
                      marginBottom="3rem"
                      display="flex"
                      justifyContent="space-between"
                    >
                      {/* <ApplyButton
                        aria-label="apply"
                        variant="extended"
                        color="primary"
                        disabled={mutationLoading || mutationData}
                        onClick={cancelEditingApplication}
                      >
                        {t('common:cancel')}
                      </ApplyButton> */}
                      <ApplyButton
                        aria-label="apply"
                        variant="extended"
                        color="primary"
                        disabled={mutationLoading || mutationData }
                        onClick={submitForm}
                      >
                        {t('common:save')}
                        <ChevronRightIcon />
                      </ApplyButton>
                    </Box>
                  )}
                </>
              );
            }}
          </Formik>
        )}
      </>
    </>
  );
};

FormBodyV2.propTypes = {
  myOpportunity: PropTypes.object.isRequired,
  applicationForm: PropTypes.object.isRequired,
  opportunitySlug: PropTypes.string.isRequired,
  preview: PropTypes.bool,
  initialValue: PropTypes.object,
  setInitialValue: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  applicationId: PropTypes.string,
  showTerms: PropTypes.bool,
  setShowTerms: PropTypes.func,
  agreeTerms: PropTypes.bool,
  setAgreeTerms: PropTypes.func,
  showApplicationForm: PropTypes.bool.isRequired,
  setShowApplicationForm: PropTypes.func.isRequired,
  multiTrack: PropTypes.bool,
  setMultiTrackApplicationForm: PropTypes.func,
  editMode: PropTypes.bool,
  handleCloseModal: PropTypes.func,
};

FormBodyV2.defaultProps = {
  preview: false,
  initialValue: {
    opportunity: '',
    track: null,
    fields: {},
    members: [],
    recaptcha: null,
  },
  applicationId: null,
  setInitialValue: () => { },
  showTerms: false,
  setShowTerms: () => { },
  agreeTerms: false,
  setAgreeTerms: () => { },
  handleCloseModal: () => { },
  multiTrack: false,
  setMultiTrackApplicationForm: () => { },
  editMode: false,
};

export default FormBodyV2;